// packages/components/src/support-ai/SolutionSelector.tsx
import React, { useState } from 'react';
import { Button } from '@dopomogai/ui';
import { Lightbulb } from 'lucide-react';
import clsx from 'clsx';

export interface SolutionOption {
  id: string;
  text: string;
  icon?: React.ReactNode;
}

interface SolutionSelectorProps {
  options: SolutionOption[];
  // FIX: The callback now passes the entire selected option object back up.
  onSelect: (option: SolutionOption) => void;
  selectedOptionId?: string | null;
}

export const SolutionSelector: React.FC<SolutionSelectorProps> = ({ options, onSelect, selectedOptionId: controlledSelectedId }) => {
  const [internalSelectedId, setInternalSelectedId] = useState<string | null>(null);

  const isControlled = controlledSelectedId !== undefined;
  const selectedId = isControlled ? controlledSelectedId : internalSelectedId;
  
  const handleSelect = (option: SolutionOption) => {
    if (!isControlled) {
        setInternalSelectedId(option.id);
    }
    // FIX: Pass the full object up to the parent.
    onSelect(option);
  };

  if (!options || options.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      <h4 className="flex items-center gap-2 text-md font-bold text-slate-800">
        <Lightbulb size={20} />
        Proposed Solutions
      </h4>
      <div className="flex flex-wrap gap-3">
        {options.map((option) => {
          const isSelected = selectedId === option.id;
          return (
            <Button
              key={option.id}
              text={option.text}
              variant={isSelected ? 'primary' : 'outline'}
              className={clsx(isSelected && "ring-2 ring-offset-2 ring-emerald-400")}
              onClick={() => handleSelect(option)}
            />
          );
        })}
      </div>
    </div>
  );
};